import socket, { invokeRPC } from './socket.js';

export function getInapplicableFiltersByProject (project_id) {
  return invokeRPC('applicability', 'getInapplicableFiltersByProject', {project_id})
}

export function getInapplicableFiltersByView (view_id) {
  return invokeRPC('applicability', 'getInapplicableFiltersByView', view_id)
}

export function updateFilterApplicability (make_inapplicable, make_applicable) {
  return invokeRPC('applicability', 'updateFilterApplicability', {make_inapplicable, make_applicable})
}

export function isTimeFrameApplicableToView (viewId) {
  return invokeRPC('applicability', 'isTimeFrameApplicableToView', viewId)
}

export function getTimeFrameInapplicableViews (project_id) {
  return invokeRPC('applicability', 'getTimeFrameInapplicableViews', {project_id})
}

export function updateTimeFrameInapplicableViews (data) {
  return invokeRPC('applicability', 'updateTimeFrameInapplicableViews', data)
}